import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const ConfirmationModal = ({ globalConfirmAction, setGlobalConfirmAction }) => {
  // Local state for modal management
  const [modal, setModal] = useState({
    open: false,
    title: "",
    message: "",
    action: null,
    type: "", // 'approve', 'disapprove', or 'delete'
  });

  // State for cancellation note
  const [cancellationNote, setCancellationNote] = useState("");

  // Handle modal close
  const handleCloseModal = () => {
    setModal({
      ...modal,
      open: false,
    });

    // Reset cancellation note if cancelling a delete operation
    if (modal.type === "delete") {
      setCancellationNote("");
    }
  };

  // Effect to sync with parent component
  React.useEffect(() => {
    if (globalConfirmAction) {
      setModal({
        open: true,
        title: globalConfirmAction.title || "",
        message: globalConfirmAction.message || "",
        action: globalConfirmAction.action || null,
        type: globalConfirmAction.type || "",
      });
      // Reset the global state
      setGlobalConfirmAction(null);
    }
  }, [globalConfirmAction, setGlobalConfirmAction]);

  // Execute action with note
  const executeAction = () => {
    if (modal.action) {
      if (modal.type === "delete" && cancellationNote) {
        modal.action(cancellationNote);
      } else {
        modal.action();
      }
    }
    handleCloseModal();
  };

  return (
    <Dialog
      open={modal.open}
      onClose={handleCloseModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          width: { xs: "95%", sm: "500px" },
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          bgcolor:
            modal.type === "approve"
              ? "rgba(76, 175, 80, 0.1)"
              : modal.type === "delete"
              ? "rgba(211, 47, 47, 0.1)"
              : "rgba(255, 152, 0, 0.1)",
          color:
            modal.type === "approve"
              ? "#388e3c"
              : modal.type === "delete"
              ? "#d32f2f"
              : "#f57c00",
          fontWeight: 500,
          pb: 1,
        }}
      >
        {modal.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ mb: 2, color: "#424242" }}
        >
          {modal.message}
        </DialogContentText>

        {/* Note input field for cancellation */}
        {modal.type === "delete" && (
          <TextField
            autoFocus
            margin="dense"
            id="cancellation-note"
            label="Note d'annulation"
            type="text"
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            value={cancellationNote}
            onChange={(e) => setCancellationNote(e.target.value)}
            required
            sx={{ mt: 2 }}
            placeholder="Veuillez expliquer la raison de l'annulation..."
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={handleCloseModal}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            color: "#666",
            borderColor: "#ccc",
            "&:hover": {
              borderColor: "#999",
              bgcolor: "#f5f5f5",
            },
          }}
        >
          Annuler
        </Button>
        <Button
          onClick={executeAction}
          variant="contained"
          autoFocus
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            bgcolor:
              modal.type === "approve"
                ? "#4caf50"
                : modal.type === "delete"
                ? "#f44336"
                : "#ff9800",
            "&:hover": {
              bgcolor:
                modal.type === "approve"
                  ? "#388e3c"
                  : modal.type === "delete"
                  ? "#d32f2f"
                  : "#f57c00",
            },
          }}
        >
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
